import Vue from 'vue'
import Router from 'vue-router'
import LoginPage from '@/components/page-login'
import SuppliersPage from '@/components/page-suppliers'
import ResellerPage from '@/components/page-reseller'
import ShopperPage from '@/components/page-shopper'
import OrdersPage from '@/components/page-orders'
import DeliveryJobsPage from '@/components/page-delivery-jobs'
import SettingsPage from '@/components/page-settings'
import DashboardTemplate from '@/components/template-dashboard'
import AssignPlacesPage from '@/components/page-assign-places'
import SendSmsPage from '@/components/page-sms'
import Newsletter from '@/components/page-newsletter'
import NewsletterList from '@/components/page-newsletter-list'
import NewsletterView from '@/components/page-newsletter-view'
import NewsletterSubsciber from '@/components/page-newsletter-subscribers'
import NewsletterSubsciberList from '@/components/page-newsletter-subscribers-list'
import store from '../store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      name: 'login',
      path: '/login',
      component: LoginPage
    },
    {
      path: '/',
      redirect: '/orders',
      children: [{
        name: 'suppliers',
        alias: 'home',
        path: '/suppliers',
        component: SuppliersPage
      }, {
        name: 'reseller',
        path: '/reseller',
        component: ResellerPage
      }, {
        name: 'shopper',
        path: '/shopper',
        component: ShopperPage
      }, {
        name: 'orders',
        path: '/orders',
        component: OrdersPage
      }, {
        name: 'orderByReference',
        path: '/orders/:referenceNumber',
        component: OrdersPage
      }, {
        name: 'deliveryJobs',
        path: 'delivery-jobs',
        component: DeliveryJobsPage
      }, {
        name: 'deliveryJobsByReference',
        path: 'delivery-jobs/:referenceNumber',
        component: DeliveryJobsPage
      }, {
        name: 'settings',
        path: 'settings',
        component: SettingsPage
      }, {
        name: 'assignPlaces',
        path: 'assign-places',
        component: AssignPlacesPage
      }, {
        name: 'SendSms',
        path: 'sms',
        component: SendSmsPage
      }, {
        name: 'Newsletter',
        path: 'Newsletter',
        component: Newsletter
      }, {
        name: 'NewsletterSubsciber',
        path: 'NewsletterSubsciber',
        component: NewsletterSubsciber
      },{
        name: 'Newsletter-subsciber',
        path: 'Newsletter-subscibers/:listName/:listId',
        component: NewsletterSubsciberList
      }, {
        name: 'Newsletter-list',
        path: 'Newsletter-list',
        component: NewsletterList
      }, {
        name: 'Newsletter-view',
        path: 'Newsletter-view/:tempID',
        component: NewsletterView
      }
    ],
      component: DashboardTemplate
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (!store.state.auth.user && to.name !== 'login') {
    next({name: 'login'})
  } else if (store.state.auth.user && to.name === 'login') {
    next({ name: 'suppliers' })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js